// extracted by mini-css-extract-plugin
module.exports = {"BusinessInfo":"businessinfo_BusinessInfo__1pHnJ","Title":"businessinfo_Title__2wux5","ActionBar":"businessinfo_ActionBar__1RL8d"};